module.exports = __webpack_public_path__ + "static/media/fvs_valve1_60.78e83b9f.jpg";